var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"currentColor"},React.createElement("g",null,React.createElement("path",{"d":"M1.066.5L20.352.5 20.352 19.646M.352 20.5L20.352.644","transform":"translate(-7296.000000, -324.000000) translate(7296.000000, 324.000000)"})))));
}

LinkArrow.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
